// tslint:disable:max-file-line-count
import { isDefined } from 'ionic-angular/util/util';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { BaseObject } from '../../core/business-objects/base-object/base-object.model';
import { entityFactory } from '../../core/helpers/entity-factory';
import { ApiRequestOptions } from '../../core/services/api/request-options';
import { VASRestService } from '../../core/services/api/vas-rest';
import { ActionOptionsArgs } from '../../core/store/actions/base-actions';
import { compareDates } from '../../core/util/compare-dates';
import { getEntityType } from '../../core/util/get-entity-type';
import { isAccountObject } from '../../core/util/is-account-object';
import { isInArray } from '../../core/util/is-in-array';
import {
    AccessGroupSchema,
    AccountSchema,
    AccountStatisticsSchema,
    ContactSchema,
    ContactTypeSchema,
    ControlSchema,
    ControlTypeSchema,
    DefaultTaskSchema,
    FieldSchema,
    FileSchema,
    FormSchema,
    GroupSchema,
    JobSchema,
    JobStatusSchema,
    JobStatusSummarySchema,
    JobTypeSchema,
    LookupSchema,
    LookupTypeSchema,
    MembershipSchema,
    NoteSchema,
    NotificationTemplateSchema,
    ReportLayoutSchema,
    ReportSchema,
    TaskSchema,
    TaskTypeSchema,
    TransitionSchema,
    UserSchema
} from '../api/schema';
import { AccessGroupApiFacade } from '../business-objects/access-group/access-group.api-facade';
import { AccessGroupFacade } from '../business-objects/access-group/access-group.facade';
import { AccessGroupStoreFacade } from '../business-objects/access-group/access-group.store-facade';
import { AccountStatisticsApiFacade } from '../business-objects/account-statistics/account-statistics.api-facade';
import { AccountStatisticsFacade } from '../business-objects/account-statistics/account-statistics.facade';
import { AccountStatisticsStoreFacade } from '../business-objects/account-statistics/account-statistics.store-facade';
import { AccountApiFacade } from '../business-objects/account/account.api-facade';
import { AccountFacade } from '../business-objects/account/account.facade';
import { Account } from '../business-objects/account/account.model';
import { AccountStoreFacade } from '../business-objects/account/account.store-facade';
import { ApiObjectFacade } from '../business-objects/api-object/api-object.facade';
import { VasBaseObjectStoreFacade } from '../business-objects/base-object/vas-base-object-store.facade';
import { VasBaseObjectApiFacade } from '../business-objects/base-object/vas-base-object.api-facade';
import { CategoryGroupApiFacade } from '../business-objects/category-group/category-group.api-facade';
import { CategoryGroupFacade } from '../business-objects/category-group/category-group.facade';
import { CategoryGroupSchema } from '../business-objects/category-group/category-group.schema';
import { CategoryGroupStoreFacade } from '../business-objects/category-group/category-group.store-facade';
import { ConfigFacade } from '../business-objects/config/config.facade';
import { ConfigStoreFacade } from '../business-objects/config/config.store-facade';
import { ContactTypeApiFacade } from '../business-objects/contact-type/contact-type.api-facade';
import { ContactTypeFacade } from '../business-objects/contact-type/contact-type.facade';
import { ContactTypeStoreFacade } from '../business-objects/contact-type/contact-type.store-facade';
import { ContactApiFacade } from '../business-objects/contact/contact.api-facade';
import { ContactFacade } from '../business-objects/contact/contact.facade';
import { ContactStoreFacade } from '../business-objects/contact/contact.store-facade';
import { ControlTypeApiFacade } from '../business-objects/control-type/control-type.api-facade';
import { ControlTypeFacade } from '../business-objects/control-type/control-type.facade';
import { ControlType } from '../business-objects/control-type/control-type.model';
import { ControlTypeStoreFacade } from '../business-objects/control-type/control-type.store-facade';
import { ControlApiFacade } from '../business-objects/control/control.api-facade';
import { ControlFacade } from '../business-objects/control/control.facade';
import { ControlStoreFacade } from '../business-objects/control/control.store-facade';
import { DefaultTaskApiFacade } from '../business-objects/default-task/default-task.api-facade';
import { DefaultTaskFacade } from '../business-objects/default-task/default-task.facade';
import { DefaultTaskStoreFacade } from '../business-objects/default-task/default-task.store-facade';
import { FieldApiFacade } from '../business-objects/field/field.api-facade';
import { FieldFacade } from '../business-objects/field/field.facade';
import { FieldStoreFacade } from '../business-objects/field/field.store-facade';
import { FileApiFacade } from '../business-objects/file/file.api-facade';
import { FileFacade } from '../business-objects/file/file.facade';
import { FileStoreFacade } from '../business-objects/file/file.store-facade';
import { FormApiFacade } from '../business-objects/form/form.api-facade';
import { FormFacade } from '../business-objects/form/form.facade';
import { Form } from '../business-objects/form/form.model';
import { FormStoreFacade } from '../business-objects/form/form.store-facade';
import { GroupApiFacade } from '../business-objects/group/group.api-facade';
import { GroupFacade } from '../business-objects/group/group.facade';
import { GroupStoreFacade } from '../business-objects/group/group.store-facade';
import { JobStatusSummaryApiFacade } from '../business-objects/job-status-summary-item/job-status-summary.api-facade';
import { JobStatusSummaryFacade } from '../business-objects/job-status-summary-item/job-status-summary.facade';
import { JobStatusSummaryStoreFacade } from '../business-objects/job-status-summary-item/job-status-summary.store-facade';
import { JobStatusApiFacade } from '../business-objects/job-status/job-status.api-facade';
import { JobStatusFacade } from '../business-objects/job-status/job-status.facade';
import { JobStatusStoreFacade } from '../business-objects/job-status/job-status.store-facade';
import { JobTypeApiFacade } from '../business-objects/job-type/job-type.api-facade';
import { JobTypeFacade } from '../business-objects/job-type/job-type.facade';
import { JobTypeStoreFacade } from '../business-objects/job-type/job-type.store-facade';
import { JobApiFacade } from '../business-objects/job/job.api-facade';
import { JobFacade } from '../business-objects/job/job.facade';
import { Job } from '../business-objects/job/job.model';
import { JobStoreFacade } from '../business-objects/job/job.store-facade';
import { LookupTypeApiFacade } from '../business-objects/lookup-type/lookup-type.api-facade';
import { LookupTypeFacade } from '../business-objects/lookup-type/lookup-type.facade';
import { LookupTypeStoreFacade } from '../business-objects/lookup-type/lookup-type.store-facade';
import { LookupApiFacade } from '../business-objects/lookup/lookup.api-facade';
import { LookupFacade } from '../business-objects/lookup/lookup.facade';
import { LookupStoreFacade } from '../business-objects/lookup/lookup.store-facade';
import { MembershipApiFacade } from '../business-objects/membership/membership.api-facade';
import { MembershipFacade } from '../business-objects/membership/membership.facade';
import { MembershipStoreFacade } from '../business-objects/membership/membership.store-facade';
import { NoteApiFacade } from '../business-objects/note/note.api-facade';
import { NoteFacade } from '../business-objects/note/note.facade';
import { NoteStoreFacade } from '../business-objects/note/note.store-facade';
import {
    NotificationTemplateApiFacade
} from '../business-objects/notification-template/notification-template.api-facade';
import { NotificationTemplateFacade } from '../business-objects/notification-template/notification-template.facade';
import { NotificationTemplateStoreFacade } from '../business-objects/notification-template/notification-template.store-facade';
import { ReportLayoutApiFacade } from '../business-objects/report-layout/report-layout.api-facade';
import { ReportLayoutFacade } from '../business-objects/report-layout/report-layout.facade';
import { ReportLayoutStoreFacade } from '../business-objects/report-layout/report-layout.store-facade';
import { ReportApiFacade } from '../business-objects/report/report.api-facade';
import { ReportFacade } from '../business-objects/report/report.facade';
import { ReportStoreFacade } from '../business-objects/report/report.store-facade';
import { SyncUpItemFacade } from '../business-objects/sync-up-item/sync-up-item.facade';
import { SyncUpItemStoreFacade } from '../business-objects/sync-up-item/sync-up-item.store-facade';
import { TaskTypeApiFacade } from '../business-objects/task-type/task-type.api-facade';
import { TaskTypeFacade } from '../business-objects/task-type/task-type.facade';
import { TaskTypeStoreFacade } from '../business-objects/task-type/task-type.store-facade';
import { TaskApiFacade } from '../business-objects/task/task.api-facade';
import { TaskFacade } from '../business-objects/task/task.facade';
import { TaskStoreFacade } from '../business-objects/task/task.store-facade';
import { TransitionApiFacade } from '../business-objects/transition/transition.api-facade';
import { TransitionFacade } from '../business-objects/transition/transition.facade';
import { TransitionStoreFacade } from '../business-objects/transition/transition.store-facade';
import { UserApiFacade } from '../business-objects/user/user.api-facade';
import { UserFacade } from '../business-objects/user/user.facade';
import { User } from '../business-objects/user/user.model';
import { UserStoreFacade } from '../business-objects/user/user.store-facade';
import { VasAppFacade } from '../services/vas-app-facade.service';
import { VasStore } from '../store/store-type';

export class ObjectsFacade {

    protected accessGroupFacade: AccessGroupFacade;
    protected accountFacade: AccountFacade;
    protected accountStatisticsFacade: AccountStatisticsFacade;
    protected categoryGroupFacade: CategoryGroupFacade;
    protected configFacade: ConfigFacade;
    protected contactFacade: ContactFacade;
    protected contactTypeFacade: ContactTypeFacade;
    protected controlFacade: ControlFacade;
    protected controlTypeFacade: ControlTypeFacade;
    protected defaultTaskFacade: DefaultTaskFacade;
    // protected externalLookupFacade: ExternalLookupFacade;
    // protected externalLookupProviderFacade: ExternalLookupProviderFacade;
    protected fieldFacade: FieldFacade;
    // protected fieldMappingFacade: FieldMappingFacade;
    protected fileFacade: FileFacade;
    protected formFacade: FormFacade;
    protected groupFacade: GroupFacade;
    protected jobFacade: JobFacade;
    protected jobStatusFacade: JobStatusFacade;
    protected jobStatusSummaryFacade: JobStatusSummaryFacade;
    protected jobTaskFacade: TaskFacade;
    protected jobTaskTypeFacade: TaskTypeFacade;
    protected jobTypeFacade: JobTypeFacade;
    protected lookupFacade: LookupFacade;
    protected lookupTypeFacade: LookupTypeFacade;
    protected membershipFacade: MembershipFacade;
    protected noteFacade: NoteFacade;
    protected notificationTemplateFacade: NotificationTemplateFacade;
    protected reportFacade: ReportFacade;
    protected reportLayoutFacade: ReportLayoutFacade;
    protected syncUpItemFacade: SyncUpItemFacade;
    protected transitionFacade: TransitionFacade;
    protected userFacade: UserFacade;

    constructor(protected appFacade: VasAppFacade, protected apiService: VASRestService, protected storeService: VasStore) {

        this.accessGroupFacade = new AccessGroupFacade(
            'accessGroup',
            appFacade,
            new AccessGroupApiFacade(appFacade, apiService, 'accessGroup'),
            new AccessGroupStoreFacade(appFacade, storeService, 'accessGroup'),
            AccessGroupSchema
        );
        this.accountFacade = new AccountFacade(
            'account',
            appFacade,
            new AccountApiFacade(appFacade, apiService, 'account'),
            new AccountStoreFacade(appFacade, storeService, 'account'),
            AccountSchema
        );
        this.accountStatisticsFacade = new AccountStatisticsFacade(
            'accountStatistics',
            appFacade,
            new AccountStatisticsApiFacade(appFacade, apiService, 'accountStatistics'),
            new AccountStatisticsStoreFacade(appFacade, storeService, 'accountStatistics'),
            AccountStatisticsSchema
        );
        this.categoryGroupFacade = new CategoryGroupFacade(
            'categoryGroup',
            appFacade,
            new CategoryGroupApiFacade(appFacade, apiService, 'categoryGroup'),
            new CategoryGroupStoreFacade(appFacade, storeService, 'categoryGroup'),
            CategoryGroupSchema
        );
        this.configFacade = new ConfigFacade(
            appFacade,
            storeService,
            new ConfigStoreFacade(appFacade, storeService)
        );
        this.contactFacade = new ContactFacade(
            'contact',
            appFacade,
            new ContactApiFacade(appFacade, apiService, 'contact'),
            new ContactStoreFacade(appFacade, storeService, 'contact'),
            ContactSchema
        );
        this.contactTypeFacade = new ContactTypeFacade(
            'contactType',
            appFacade,
            new ContactTypeApiFacade(appFacade, apiService, 'contactType'),
            new ContactTypeStoreFacade(appFacade, storeService, 'contactType'),
            ContactTypeSchema
        );
        this.controlFacade = new ControlFacade(
            'control',
            appFacade,
            new ControlApiFacade(appFacade, apiService, 'control'),
            new ControlStoreFacade(appFacade, storeService, 'control'),
            ControlSchema
        );
        this.controlTypeFacade = new ControlTypeFacade(
            'controlType',
            appFacade,
            new ControlTypeApiFacade(appFacade, apiService, 'controlType'),
            new ControlTypeStoreFacade(appFacade, storeService, 'controlType'),
            ControlTypeSchema
        );

        this.defaultTaskFacade = new DefaultTaskFacade(
            'defaultTask',
            appFacade,
            new DefaultTaskApiFacade(appFacade, apiService, 'defaultTask'),
            new DefaultTaskStoreFacade(appFacade, storeService, 'defaultTask'),
            DefaultTaskSchema
        );

        this.fieldFacade = new FieldFacade(
            'field',
            appFacade,
            new FieldApiFacade(appFacade, apiService, 'field'),
            new FieldStoreFacade(appFacade, storeService, 'field'),
            FieldSchema
        );
        this.fileFacade = new FileFacade(
            'file',
            appFacade,
            new FileApiFacade(appFacade, apiService, 'file'),
            new FileStoreFacade(appFacade, storeService, 'file'),
            FileSchema
        );
        this.formFacade = new FormFacade(
            'form',
            appFacade,
            new FormApiFacade(appFacade, apiService, 'form'),
            new FormStoreFacade(appFacade, storeService, 'form'),
            FormSchema
        );
        this.groupFacade = new GroupFacade(
            'group',
            appFacade,
            new GroupApiFacade(appFacade, apiService, 'group'),
            new GroupStoreFacade(appFacade, storeService, 'group'),
            GroupSchema
        );
        this.jobFacade = new JobFacade(
            'job',
            appFacade,
            new JobApiFacade(appFacade, apiService, 'job'),
            new JobStoreFacade(appFacade, storeService, 'job'),
            JobSchema
        );
        this.jobStatusFacade = new JobStatusFacade(
            'jobStatus',
            appFacade,
            new JobStatusApiFacade(appFacade, apiService, 'jobStatus'),
            new JobStatusStoreFacade(appFacade, storeService, 'jobStatus'),
            JobStatusSchema
        );
        this.jobStatusSummaryFacade = new JobStatusSummaryFacade(
            'jobStatusSummary',
            appFacade,
            new JobStatusSummaryApiFacade(appFacade, apiService, 'jobStatusSummary'),
            new JobStatusSummaryStoreFacade(appFacade, storeService, 'jobStatusSummary'),
            JobStatusSummarySchema
        );
        this.jobTaskFacade = new TaskFacade(
            'task',
            appFacade,
            new TaskApiFacade(appFacade, apiService, 'task'),
            new TaskStoreFacade(appFacade, storeService, 'task'),
            TaskSchema);
        this.jobTaskTypeFacade = new TaskTypeFacade(
            'taskType',
            appFacade,
            new TaskTypeApiFacade(appFacade, apiService, 'taskType'),
            new TaskTypeStoreFacade(appFacade, storeService, 'taskType'),
            TaskTypeSchema
        );
        this.jobTypeFacade = new JobTypeFacade(
            'jobType',
            appFacade,
            new JobTypeApiFacade(appFacade, apiService, 'jobType'),
            new JobTypeStoreFacade(appFacade, storeService, 'jobType'),
            JobTypeSchema
        );
        this.lookupFacade = new LookupFacade(
            'lookup',
            appFacade,
            new LookupApiFacade(appFacade, apiService, 'lookup'),
            new LookupStoreFacade(appFacade, storeService, 'lookup'),
            LookupSchema
        );
        this.lookupTypeFacade = new LookupTypeFacade(
            'lookupType',
            appFacade,
            new LookupTypeApiFacade(appFacade, apiService, 'lookupType'),
            new LookupTypeStoreFacade(appFacade, storeService, 'lookupType'),
            LookupTypeSchema
        );
        this.membershipFacade = new MembershipFacade(
            'membership',
            appFacade,
            new MembershipApiFacade(appFacade, apiService, 'membership'),
            new MembershipStoreFacade(appFacade, storeService, 'membership'),
            MembershipSchema
        );
        this.noteFacade = new NoteFacade(
            'note',
            appFacade,
            new NoteApiFacade(appFacade, apiService, 'note'),
            new NoteStoreFacade(appFacade, storeService, 'note'),
            NoteSchema
        );
        this.notificationTemplateFacade = new NotificationTemplateFacade(
            'notificationTemplate',
            appFacade,
            new NotificationTemplateApiFacade(appFacade, apiService, 'notificationTemplate'),
            new NotificationTemplateStoreFacade(appFacade, storeService, 'notificationTemplate'),
            NotificationTemplateSchema
        );
        this.reportFacade = new ReportFacade(
            'report',
            appFacade,
            new ReportApiFacade(appFacade, apiService, 'report'),
            new ReportStoreFacade(appFacade, storeService, 'report'),
            ReportSchema
        );
        this.reportLayoutFacade = new ReportLayoutFacade(
            'reportLayout',
            appFacade,
            new ReportLayoutApiFacade(appFacade, apiService, 'reportLayout'),
            new ReportLayoutStoreFacade(appFacade, storeService, 'reportLayout'),
            ReportLayoutSchema
        );
        this.syncUpItemFacade = new SyncUpItemFacade(
            'syncUpItem',
            appFacade,
            undefined,
            new SyncUpItemStoreFacade(appFacade, storeService, 'syncUpItem'),
            undefined
        );
        this.transitionFacade = new TransitionFacade(
            'transition',
            appFacade,
            new TransitionApiFacade(appFacade, apiService, 'transition'),
            new TransitionStoreFacade(appFacade, storeService, 'transition'),
            TransitionSchema
        );
        this.userFacade = new UserFacade(
            'user',
            appFacade,
            new UserApiFacade(appFacade, apiService, 'user'),
            new UserStoreFacade(appFacade, storeService, 'user'),
            UserSchema
        );
    }

    get accessGroup(): AccessGroupFacade {
        return this.accessGroupFacade;
    }

    get account(): AccountFacade {
        return this.accountFacade;
    }

    get accountStatistics(): AccountStatisticsFacade {
        return this.accountStatisticsFacade;
    }

    get categoryGroup(): CategoryGroupFacade {
        return this.categoryGroupFacade;
    }

    get config(): ConfigFacade {
        return this.configFacade;
    }

    get contact(): ContactFacade {
        return this.contactFacade;
    }

    get contactType(): ContactTypeFacade {
        return this.contactTypeFacade;
    }

    get control(): ControlFacade {
        return this.controlFacade;
    }

    get controlType(): ControlTypeFacade {
        return this.controlTypeFacade;
    }

    get defaultTask(): DefaultTaskFacade {
        return this.defaultTaskFacade;
    }

    // get externalLookup(): ExternalLookupFacade {
    //     return this.externalLookup;
    // }

    // get externalLookupProvider(): ExternalLookupProviderFacade {
    //     return this.externalLookupProvider;
    // }

    get field(): FieldFacade {
        return this.fieldFacade;
    }

    // get fieldMapping(): FieldMappingFacade {
    //     return this.fieldMapping;
    // }

    get file(): FileFacade {
        return this.fileFacade;
    }

    get form(): FormFacade {
        return this.formFacade;
    }

    get group(): GroupFacade {
        return this.groupFacade;
    }

    get job(): JobFacade {
        return this.jobFacade;
    }

    get jobStatus(): JobStatusFacade {
        return this.jobStatusFacade;
    }

    get jobStatusSummary(): JobStatusSummaryFacade {
        return this.jobStatusSummaryFacade;
    }

    get jobType(): JobTypeFacade {
        return this.jobTypeFacade;
    }

    get lookup(): LookupFacade {
        return this.lookupFacade;
    }

    get lookupType(): LookupTypeFacade {
        return this.lookupTypeFacade;
    }

    get membership(): MembershipFacade {
        return this.membershipFacade;
    }

    get note(): NoteFacade {
        return this.noteFacade;
    }

    get notificationTemplate(): NotificationTemplateFacade {
        return this.notificationTemplateFacade;
    }

    get report(): ReportFacade {
        return this.reportFacade;
    }

    get reportLayout(): ReportLayoutFacade {
        return this.reportLayoutFacade;
    }

    get syncUpItem(): SyncUpItemFacade {
        return this.syncUpItemFacade;
    }

    get task(): TaskFacade {
        return this.jobTaskFacade;
    }

    get taskType(): TaskTypeFacade {
        return this.jobTaskTypeFacade;
    }

    get transition(): TransitionFacade {
        return this.transitionFacade;
    }

    get user(): UserFacade {
        return this.userFacade;
    }

    getFacadeByEntity(entity: string): ApiObjectFacade<BaseObject, VasBaseObjectApiFacade<BaseObject>, VasBaseObjectStoreFacade<BaseObject>> {
        if (!isDefined(this[entity])) {
            throw new Error(`facade for entity ${entity} not found`);
        }
        return this[entity];
    }

    getObject(entity: string, id: string): Observable<BaseObject> {

        try {
            return this[entity].store.get(id);
        } catch (e) {
            console.error(e);
            throw new Error(`invalid entity '${entity}'. ${e.message}`);
        }
    }

    getObjects(entity: string): Observable<Array<BaseObject>> {
        try {
            return this[entity].store.getAll();
        } catch (e) {
            console.error(e);
            throw new Error(`invalid entity '${entity}'. ${e.message}`);
        }
    }

    upsertObject(entity: string, object: BaseObject): void {
        try {
            return this.getFacadeByEntity(entity).store.upsert(object);
        } catch (e) {
            console.error(e);
            throw new Error(`invalid entity '${entity}'. ${e.message}`);
        }
    }

    updateObject(entity: string, object: BaseObject): void {
        try {
            return this.getFacadeByEntity(entity).store.update(object);
        } catch (e) {
            console.error(e);
            throw new Error(`invalid entity '${entity}'. ${e.message}`);
        }
    }

    insertObject(entity: string, object: BaseObject): void {

        try {
            return this.getFacadeByEntity(entity).store.insert(entityFactory(entity, object));
        } catch (e) {
            console.error(e);
            throw new Error(`invalid entity '${entity}'. ${e.message}`);
        }
    }

    insertObjectIfFresher(entity: string, instance: BaseObject): void {

        if (this.isLocalFresher(entity, instance)) {
            return;
        }

        if (this.isChangePending(instance.id)) {
            return;
        }

        this.insertObject(entity, instance);
    }

    removeObject(entity: string, object: BaseObject, options?: ActionOptionsArgs): void {
        try {
            return this.getFacadeByEntity(entity).store.remove(object, options);
        } catch (e) {
            console.error(e);
            throw new Error(`invalid entity '${entity}'. ${e.message}`);
        }
    }

    syncEntity(entity: string, options?: ApiRequestOptions): Observable<any> {
        try {
            return this.getFacadeByEntity(entity).syncAll(options);
        } catch (e) {
            console.error(e);
            throw new Error(`invalid entity '${entity}'. ${e.message}`);
        }
    }

    syncObject(object: BaseObject, options?: ApiRequestOptions): Observable<any> {

        const entity = getEntityType(object);

        if (isAccountObject(object)) {
            const facade = this.getFacadeByEntity(entity);
            return facade.syncOne(object.account, object.id, options);
        } else if (object instanceof Account) {
            const facade = this.getFacadeByEntity(entity);
            return facade.syncOne(object.id, options);
        } else if (object instanceof User) {
            const facade = this.getFacadeByEntity(entity);
            return facade.syncOne(object.id, options);
        } else if (object instanceof ControlType) {
            return this.controlType.syncOne(object.id, options);
        }

        console.warn('syncObject called on an object without an identifiable facade');
        return of(undefined);
    }

    /**
     * Compares the serverModified value of the local (read from state) and remote copies of the object
     * returns true if the local copy is fresher than the remote copy or they have the same modified date
     * @param entity
     * @param remote
     * @returns {boolean}
     */
    isLocalFresher(entity: string, remote: BaseObject): boolean {
        let local: BaseObject;
        const id = remote.id;
        let result = false;

        this.getObject(entity, id)
            .take(1)
            .subscribe((object: BaseObject) => local = object);

        if (local) {
            result = compareDates(local.serverModified, remote.serverModified) >= 0;

            if (compareDates(local.modified, remote.modified) > 0) {
                return false;
            }

            // @todo this is a bit of a nasty workaround for https://git.ironcode.io/vas/vas-mobile/issues/496
            // @todo we should be able to check if `local instanceof Job` but for some reason sometimes we are getting
            // an instance of Object instead of Job (something to do with the store hydrator)
            if (result && isDefined((local as Job).reference)) {
                const lJob = new Job(local as Job);
                const rJob = new Job(remote as Job);
                return lJob.isFresherThan(rJob);
            }

            if (result && isDefined((local as Form).groups)) {
                const localHash = [...(local as Form).groups]
                    .sort((a, b) => a.localeCompare(b))
                    .reduce((p, c) => p + c, '');
                const remoteHash = [...(remote as Form).groups]
                    .sort((a, b) => a.localeCompare(b))
                    .reduce((p, c) => p + c, '');
                return localHash === remoteHash;
            }
        }

        return result;

    }

    /**
     * Returns true if a change q item for the specified object id exists
     * @param id
     * @returns {boolean}
     */
    isChangePending(id: string): boolean {
        return this.appFacade.changeLog.isChangePending(id);
    }

    /**
     * Remove objects from the store if their id is in a but not in b.
     * Note the action is performed with restful=false
     * @param {string} entity
     * @param {Array<BaseObject>} a
     * @param {Array<BaseObject>} b
     * @param {ActionOptionsArgs} options
     */
    diffAndRemove(entity: string, a: Array<BaseObject>, b: Array<BaseObject>, options?: ActionOptionsArgs): void {
        a = a || [];
        b = b || [];
        const bIds = b.map(object => object.id);
        a
            .filter(lo => !isInArray(lo.id, bIds))
            .forEach(lo => this.removeObject(entity, lo, options));
    }
}



// WEBPACK FOOTER //
// ./src/vas/facades/objects.facade.ts